<template>
    <div class="form-container">
        <template v-if="!isSubmitted">
            <slot name="step"></slot>
            <slot name="progress"></slot>
        </template>
        <template v-else>
            <slot name="success"></slot>
        </template>
    </div>
</template>

<script>
    import { UnSavedMixin } from '@/mixins/UnSavedMixin';

    export default {
        name: 'BaseStepForm',
        mixins: [UnSavedMixin],
        props: {
            isSubmitted: {
                type: Boolean,
                required: true
            },
            isDirty: {
                type: Boolean,
                required: true
            },
            resetCallback: {
                type: Function,
                required: true
            },
            prefillCallback: {
                type: Function,
                required: true
            }
        },
        created() {
            const { id } = this.$route.params;
            id && this.prefillCallback(id);
        },
        beforeDestroy() {
            this.resetCallback();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../assets/colors";

    .form-container {
        padding: 34px 8%;
        display: flex;
        width: 100%;
        max-width: 100%;
        justify-content: center;
        @media screen and (max-width: 1400px){
            padding: 34px 4%;
        }
        @media screen and (max-width: 1200px){
            padding: 34px 2%;
        }
        @media screen and (max-width: 991px){
            display: flex;
            flex-direction: column-reverse;
        }
        @media screen and (max-width: 767px){
            padding: 34px 20px;
        }
        @media screen and (max-width: 576px){
            padding: 34px 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/base/BaseStepForm.vue